/**
 * @author Daniel Aguirre
 * @file index.js
 * @description Dashboard Filter Component
 */

// Styles
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import PropTypes from 'prop-types';

// Styles
import styles from './styles.module.css';

const DashboardFilter = ({ menuItems, label, onSelectItem, current }) => {
  const menu = (
    <Menu onClick={onSelectItem} selectable>
      {menuItems?.map(({ key, value }) => (
        <Menu.Item key={key}>{value}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <>
      <span className={styles.customLabel}>{label}:</span>
      <Dropdown overlay={menu} trigger={['click']}>
        <div className={styles.customDropdownInput}>
          <div className="flex flex-row w-full">
            <span className={styles.customSelectedOption}>{current}</span>
          </div>
          <DownOutlined className={styles.customDropdownArrow} />
        </div>
      </Dropdown>
    </>
  );
};

/**
 * Component definition of proptypes.
 */
DashboardFilter.propTypes = {
  menuItems: PropTypes.array,
  label: PropTypes.string,
  current: PropTypes.string,
  onSelectItem: PropTypes.func
};

export default DashboardFilter;
